module.exports = __webpack_public_path__ + "static/homepage-hero-tvc-portrait-1080w-3f610c0dbd30289ed80f8fc8d5ed2c7c.jpg";